<template>
  <v-card color="grey lighten-3" class="pa-2 mb-3">
    <v-card-title>
      <h4 class="subheading my-0">Datos de la remuneración</h4>
    </v-card-title>
    <v-layout wrap>
      <v-flex xs6 pr-3>
        <v-select
          v-model="formData.remuneracion_bruta"
          :disabled="disabled"
          @input="$emit('input', formData)"
          :label="$t('Remuneración bruta anual')"
          :items="tiposDeRemuneracion"
          :rules="[rules.required]"
          required
          item-text="label"
          item-value="value"
          box
          :menu-props="{
            bottom: true,
            'offset-y': true,
          }"
        >
          <template slot="prepend">
            <v-btn @click="toggleInfo()" class="mt-0 pt-0" flat icon color="secondary">
              <v-icon small>mdi-information</v-icon>
            </v-btn>
          </template>
        </v-select>
      </v-flex>

      <v-flex xs6>
        <template v-if="formData.remuneracion_bruta === 'pactada'">
          <v-text-field
            v-model="formData.remuneracion_bruta_cantidad"
            :disabled="disabled"
            :rules="[rules.required]"
            type="number"
            :label="$t('Remuneración pactada')"
            box
          ></v-text-field>
        </template>
      </v-flex>
    </v-layout>
    <v-layout wrap v-if="showInfo">
      <v-flex xs12>
        <v-alert v-model="showInfo" color="blue-grey" dismissible type="info" class="mb-3">
          <p>
            El
            <b>salario bruto</b>
            es el total antes de que se produzcan retenciones y cotizaciones. El
            <b>salario neto</b>
            es, en último término, lo que el trabajador realmente percibe, es decir, el dinero
            correspondiente a su sueldo que ingresa en su cuenta bancaria una vez se le han aplicado
            las retenciones y cotizaciones a la Seguridad Social.
          </p>
          <p>
            Pero ¿en qué consisten exactamente estos pagos y cuánto restan a un sueldo normal? Las
            cantidades que se restan del salario son las correspondientes al
            <b>Impuesto de la Renta de las Personas Físicas (IRPF)</b>
            y a la cuota que se entrega a la
            <b>Seguridad Social.</b>
            La primera de ellas es una cantidad que el Estado retiene al trabajador en previsión de
            lo que después deberá pagar a Hacienda en su declaración de la renta. De esta forma, al
            hacer su declaración tendrá estas cantidades reflejadas en los cálculos como entregas a
            cuenta del resultado de la declaración.
          </p>
        </v-alert>
      </v-flex>
    </v-layout>

    <v-select
      v-model="formData.numero_de_pagas"
      :disabled="disabled"
      @input="$emit('input', formData)"
      :label="$t('Nº Pagas')"
      :items="tiposDeNumeroDePagas"
      :rules="[rules.required]"
      required
      item-text="label"
      item-value="value"
      box
      :menu-props="{
        bottom: true,
        'offset-y': true,
      }"
    ></v-select>
  </v-card>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          remuneracion_bruta: null,
          remuneracion_bruta_cantidad: null,
          numero_de_pagas: null,
        };
      },
    },
  },
  data() {
    return {
      showInfo: false,
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
      tiposDeRemuneracion: [
        { label: 'Remuneración según convenio', value: 'convenio' },
        { label: 'Remuneración pactada', value: 'pactada' },
      ],
      tiposDeNumeroDePagas: [
        { label: '14 pagas', value: '14' },
        { label: '12 pagas prorrateadas', value: '12' },
      ],
    };
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {},
  methods: {
    toggleInfo() {
      this.showInfo = !this.showInfo;
    },
  },
  watch: {},
};
</script>

<style lang="scss"></style>
